import { IMediaSupportServiceStrategy } from 'affiny-core/services/MediaSupportStrategy';

export class MediaSupportWebStrategy implements IMediaSupportServiceStrategy {
  public setAcceptHeader() {
    const acceptPicturesFormat = localStorage.getItem(
      'header-accept-pictures-format'
    );

    if (!acceptPicturesFormat) {
      const defaultFormat = 'image/apng,image/svg+xml,image/*,*';

      const webpTestPictures = {
        lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
        lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
        alpha:
          'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
        animation:
          'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
      };

      const webpTestPicturesKeys = Object.keys(webpTestPictures);

      webpTestPicturesKeys.forEach((type, index) => {
        const image = new Image();

        image.onload = () => {
          if (
            image.width > 0 &&
            image.height > 0 &&
            index + 1 === webpTestPicturesKeys.length
          ) {
            return localStorage.setItem(
              'header-accept-pictures-format',
              `image/avif,image/webp,${defaultFormat}`
            );
          }
        };

        image.onerror = () => {
          return localStorage.setItem(
            'header-accept-pictures-format',
            `image/avif,${defaultFormat}`
          );
        };

        image.src = `data:image/webp;base64,${webpTestPictures[type]}`;
      });
    }
  }

  public getAcceptHeader = () =>
    new Promise<string>(resolve =>
      resolve(
        localStorage.getItem('header-accept-pictures-format') ||
          'image/avif,image/apng,image/svg+xml,image/*,*'
      )
    );
}
